import React from 'react';
import AdminLayout from 'cms/core/shared/AdminLayout';
import CompanyList from '../components/CompanyList';

const CompanyScreen = () => {
  return (
    <AdminLayout pageTitle="Companies">
      <CompanyList />
    </AdminLayout>
  );
};

export default CompanyScreen;

